import React, { useState } from 'react';

import Dashboardnavbar from '../../layout/Dashboardnavbar';
// import { SiteDesignationTable, SiteSubcompanyTable, SiteEmployeeDetails, ConsultantAccountDetails, SiteDepartment } from './WorkforceTable';
import usePermission from '../../config/permissions';
// import usePermission from '../../config/permissions';
import Miscellaneous from '../Miscellaneous/Miscellaneous';
import Ticket from '../TicketBooking/Ticket';
const ProjectExpense = () => {


    const siteRole = sessionStorage.getItem("sitemanagement_role")

    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {


            case 1:
                return 'Miscellaneous Table';
            case 2:
                return 'Ticket Table'

            default:
                return 'Miscellaneous Table';
        }
    };


    return (
        <>
            <Dashboardnavbar name={getSelectedTitle()} url="projectexpense" />
            {/* {(siteRole !== "SiteManagement" && siteRole === "Admin") &&
                (

                    <div className='content-tabs'>
                        <div className="toggle-button-area" style={{ padding: "34px 30px" }}>




                            <button
                                className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                onClick={() => setToggleState(1)}
                            >
                                Office Rent
                            </button>
                            <button
                                className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                onClick={() => setToggleState(2)}
                            >
                                Office Billing Details
                            </button>
                        </div>
                    </div>
                )
            } */}
            <div className='content-tabs'>
                <div className="toggle-button-area" style={{ padding: "34px 30px" }}>




                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        Miscellaneous Table
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        Ticket Table
                    </button>
                </div>
            </div>
            <div className="content-tabs">
                {toggleState === 1 ? <Miscellaneous /> : null}
                {toggleState === 2 ? <Ticket /> : null}


            </div>
        </>
    );
};





export default ProjectExpense;